import type { ThemeTokens } from './types';

/** Fields that are handled outside of CSS setProperty (meta + font link). */
type MetaKey = 'id' | 'name' | 'colorMode' | 'googleFontsUrl';
type CssTokenKey = keyof Omit<ThemeTokens, MetaKey>;

/**
 * Maps each ThemeTokens field to its CSS custom property name.
 * This is the single source of truth — applyTheme iterates this map.
 */
export const TOKEN_MAP: Record<CssTokenKey, string> = {
  // Brand
  primaryColor:    '--primary-color',
  primaryLight:    '--primary-light',
  primaryDark:     '--primary-dark',
  primarySubtle:   '--primary-subtle',
  hoverColor:      '--hover-color',
  activeColor:     '--active-color',
  buttonFocusRing: '--button-focus-ring',
  shadowPrimary:   '--shadow-primary',
  shadowPrimarySm: '--shadow-primary-sm',
  gradientBrand:   '--gradient-brand',
  gradientBrandR:  '--gradient-brand-r',
  gradientSubtle:  '--gradient-subtle',
  infoColor:       '--info-color',

  // Brand alpha
  primaryAlpha12: '--primary-alpha-12',
  primaryAlpha15: '--primary-alpha-15',
  primaryAlpha18: '--primary-alpha-18',
  primaryAlpha20: '--primary-alpha-20',
  primaryAlpha25: '--primary-alpha-25',
  primaryAlpha30: '--primary-alpha-30',
  primaryAlpha35: '--primary-alpha-35',
  primaryAlpha40: '--primary-alpha-40',

  // Surface
  bgColor:     '--bg-color',
  bgSubtle:    '--bg-subtle',
  cardBgColor: '--card-bg-color',

  // Text
  textDark:    '--text-dark',
  textMedium:  '--text-medium',
  textLight:   '--text-light',
  textInverse: '--text-inverse',

  // Border
  borderColor:  '--border-color',
  borderLight:  '--border-light',

  // Shadows
  shadowXs: '--shadow-xs',
  shadowSm: '--shadow-sm',
  shadowMd: '--shadow-md',
  shadowLg: '--shadow-lg',
  shadowXl: '--shadow-xl',

  // Status
  successBg:     '--success-bg',
  successBorder: '--success-border',
  successText:   '--success-text',
  warningBg:     '--warning-bg',
  warningBorder: '--warning-border',
  warningText:   '--warning-text',
  dangerBg:      '--danger-bg',
  dangerBorder:  '--danger-border',
  dangerText:    '--danger-text',
  infoBg:        '--info-bg',
  infoBorder:    '--info-border',
  infoText:      '--info-text',

  // Interaction
  dangerHoverBg: '--danger-hover-bg',
  backdropColor: '--backdrop-color',

  // Fonts
  fontSans:    '--font-sans',
  fontMono:    '--font-mono',
  fontDisplay: '--font-display',
};
